import React, { Component } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move'; // Importación corregida

import { connect } from 'react-redux';
import { fetchPublicacion, editPublicacion, setImagesUploader } from '../../../../actions/publicacionesActions';
import { updateImagenesApi } from '../../../../api/axios';
import { toast } from 'react-toastify';
import { createImageUrl } from '../../../../api/axios';

// Componente para cada imagen individual
const SortableItem = SortableElement(({ image, onDelete }) => (
    //<div style={{ margin: '10px' }}>
    //    <img src={image.urlImagen} alt={image.name} width="100" height="100" />
    //    <button onClick={onDelete}>Eliminar</button>
    //</div>

    <div style={{ margin: '10px' }}>
        <div style={{ margin: '10px' }}>
            <img
                src={image.urlImagen}
                alt={image.name}
                style={{
                    width: '250px',
                    height: 'auto',
                    maxHeight: '250px',
                    objectFit: 'contain',
                    marginRight: '10px' // Espacio entre la imagen y el botón
                }}
            />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button className="btn btn-light" onClick={onDelete} style={{ width: '40px', height: '40px' }}>
                <i className="fas fa-trash-alt" style={{ pointerEvents: 'none' }} ></i>
            </button>
        </div>
    </div>


    // <div style={{ margin: '10px', textAlign: 'center' }}>
    //    <img
    //        src={image.urlImagen}
    //        alt={image.name}
    //        style={{
    //            width: '250px',
    //            height: 'auto',
    //            maxHeight: '250px',
    //            objectFit: 'contain'
    //        }}
    //    />
    //    <button
    //        onClick={onDelete}
    //        style={{
    //            background: 'none',
    //            border: 'none',
    //            cursor: 'pointer',
    //            marginTop: '5px'
    //        }}
    //    >
    //        <i class="fas fa-trash-alt" style={{ fontSize: '20px', color: '#333' }}></i>
    //    </button>


    //</div> 


));

// Componente para la lista de imágenes
const SortableList = SortableContainer(({ items, onDelete }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {(items || []).map((image, index) => {
            image.posicion = index; // Modificación directa del objeto
            return (
                <SortableItem
                    key={image.urlImagen || `item-${index}`}
                    index={index}
                    image={image}
                    //onDelete={() => onDelete(image)} // Función de eliminación
                    onDelete={(e) => (e.preventDefault(), onDelete(image))}
                />
            );
        })}
    </div>
));

// Componente principal basado en clase
class ImageUploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            //images: [
            //    { urlImagen: 'https://www.megatone.net/images/Articulos/zoom2x/104/MKT0423LTA-1.jpg', name: 'Image 1', position: 0 },
            //],
        };
    }

    componentDidMount() {
        if (!this.state.images.length) {
            this.setState({ images: this.props.publicacion.imagenes || [] });
        }
    }

    // Maneja la carga de nuevas imágenes
    handleImageUpload = (event) => {
        const files = Array.from(event.target.files);
        const image = event.target.files[0];

        // 500 KB en bytes
        if (image.size > 512000) {
            toast.error("Tamaño de imagen debe ser menor a 500kb");
            return;
        }

        const newImages = files.map((file) => ({
            urlImagen: URL.createObjectURL(file),
            name: file.name,
            posicion: (this.state.images || []).length,
            imagen: file
        }));
        this.setState(
            (prevState) => ({
                images: [...(prevState.images || []), ...newImages],
            }),
            () => {
                this.props.setImagesUploader(this.state.images, true);
            }
        );
    };

    // Maneja la reorganización de imágenes
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(
            (prevState) => ({
                images: arrayMoveImmutable(prevState.images || [], oldIndex, newIndex),
            }),
            () => {
                this.props.setImagesUploader(this.state.images, true);
            }
        );
    };

    // Maneja la eliminación de imágenes
    handleDeleteImage = (imageToDelete) => {
        URL.revokeObjectURL(imageToDelete.urlImagen);

        this.setState(
            (prevState) => ({
                images: (prevState.images || []).filter((image) => image !== imageToDelete),
            }),
            () => {
                this.props.setImagesUploader(this.state.images, true);
            }
        );
    };


    onSubmit = async (event) => {
        event.preventDefault();

        // Copia del estado para trabajar sin mutarlo directamente
        const updatedImages = [...this.state.images];

        try {
            // Array de promesas para crear URLs de cada imagen
            const urlRequests = updatedImages.map(async (img, index) => {
                if (img.imagen !== undefined) {
                    const res = await createImageUrl(img.imagen);
                    if (res !== "") {
                        // Asigna el URL devuelto a la imagen
                        updatedImages[index] = {
                            ...img,
                            urlImagen: res.url
                        };
                    } else {
                        toast.error("Error en la URL de la imagen");
                    }
                }
            });

            // Espera a que todas las URLs se hayan generado
            await Promise.all(urlRequests);

            // Actualiza el estado con las imágenes procesadas
            this.setState({ images: updatedImages }, () => {
                this.props.publicacion.imagenes = updatedImages;
            });

            // Crea el payload para la API
            const imagenesBulk = updatedImages.map(img => ({
                posicion: img.posicion,
                urlImagen: img.urlImagen
            }));

            const updateImagenesRequest = {
                idUser: this.props.userId,
                actualizarImagenesBulks: [
                    {
                        idPublicacion: this.props.publicacion.idPublicacion,
                        imagenes: imagenesBulk
                    }
                ]
            };

            // Llamada a la API
            const res = await updateImagenesApi(updateImagenesRequest);
            toast.success("Imágenes editadas");

        } catch (err) {
            if (err.response && err.response.data.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No pudo editarse");
            }
        }
    };


    render() {
        const { images } = this.state;

        return (
            <div>
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={this.handleImageUpload}
                    style={{ marginBottom: '20px' }}
                />
                <SortableList
                    items={images}
                    onSortEnd={this.onSortEnd}
                    axis="xy"
                    onDelete={this.handleDeleteImage}
                //onDelete={(e) => (e.stopPropagation(), this.handleDeleteImage)}
                />

                {/*<div>
                    <button
                        //hidden={!this.props.publicacion.idPublicacion}
                        onClick={this.onSubmit}
                        type="submit"
                        className="btn pt-2 m-r-10 btn-sm background-rojo-megatone waves-light mb-md-5"
                    //disabled={this.state.changeImages}
                    >
                        Guardar Imagenes
                </button>
                </div>*/}
            </div>

        );
    }
}

//export default ImageUploader;
const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    userId: state.general.userId,
    imagesUploader: state.publicaciones.imagesUploader,
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion, setImagesUploader })(ImageUploader);